import AppError from '@App/error/AppError';

export default class NotFoundError extends AppError {
    static CODE = 'not-found';
}
